/**
 * The answer texts the cards post into the chat. The agent's tools and prompts match these exact strings
 * (request_document, record_unavailable, the continue checkpoint), so change them only with the backend.
 */

/** A document the user uploaded for a request. */
export const uploadedMessage = (filename: string, description: string) => `Uploaded ${filename} for: ${description}`

/** The user does not have the document. The agent records it and carries on without it. */
export const unavailableMessage = (description: string) =>
  `Not available: ${description}. Please call record_unavailable for it and carry on without it.`

/** The document is already in the case (uploaded earlier, or in the Matter). */
export const alreadyInMessage = (filename: string, description: string) => `It's already in: ${filename} for: ${description}`

/** The options on a `continue` checkpoint: resume drafting, or stop with the partial draft. */
export const CONTINUE_OPTIONS = ["Resume", "Stop here"] as const
